import React from 'react';
import PropTypes from 'prop-types';
/* Components */
import Modal from '../../common/modal/modal';

class ResetConfigurationModal extends React.PureComponent {
  handleReset = () => {
    this.props.onConfirm();
    this.props.onClose();
  };

  closeAndDiscard = () => {
    this.props.onClose();
  };

  render() {
    return (
      <Modal.Default isOpen={this.props.isOpen}>
        <div className="glu-modal__header glu-flex glu-flex-align-center">
          <div className="glu-modal__title glu-flex-grow">Reset dashboard?</div>
          <div className="glu-flex-shrink">
            <button
              aria-label="close"
              type="button"
              className="glu-btn-link g-icon g-icon-close"
              onClick={this.closeAndDiscard}
            />
          </div>
        </div>
        <div className="glu-modal__body">
          <div className="glu-content__section">
            <p className="glu-h5 glu-dashboard-reset-configuration text-secondary--line-height">
              Are you sure you want to reset the <b>{this.props.dashboardName}</b> Dashboard?
              <br />
              This Dashboard will lose all the configured widgets that you have added, and you will
              start from the beginning.
            </p>
          </div>
        </div>
        <footer className="glu-modal__footer">
          <div className="glu-flex-grow glu-flex-row">
            <div className="glu-flex-grow text-right">
              <button
                type="button"
                onClick={this.closeAndDiscard}
                className="glu-btn glu-btn--secondary"
              >
                Cancel
              </button>
            </div>
            <div className="glu-flex-shrink">
              <button className="glu-btn glu-btn--primary" onClick={this.handleReset}>
                Save
              </button>
            </div>
          </div>
        </footer>
      </Modal.Default>
    );
  }
}

ResetConfigurationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  dashboardName: PropTypes.string.isRequired,
};

export default ResetConfigurationModal;
